import React from 'react';
import { View, ViewStyle, StyleProp, TextStyle } from 'react-native';
import { translate } from '../services/translate';
import CustomButton, { ButtonTypes } from './CustomButton';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

interface FormInputProps {
    onSubmit: () => void;
    onClose: () => void;
    disabled: boolean;
    cancelText?: string;
    cancelType?: ButtonTypes;
    confirmText?: string;
    confirmType?: ButtonTypes;
    viewStyle?: StyleProp<ViewStyle>;
    isLoading?: boolean;
    buttonStyle?: StyleProp<ViewStyle>;
    buttonContentContainerStyle?: StyleProp<ViewStyle>;
    textStyle?: TextStyle;
}

export default function FormActions({
    onSubmit,
    onClose,
    disabled,
    viewStyle,
    cancelText = 'cancel',
    cancelType = 'secondary',
    confirmText = 'save',
    confirmType = 'primary',
    isLoading,
    buttonStyle,
    buttonContentContainerStyle,
    textStyle
}: FormInputProps) {
    const { styles } = useStyles(styleSheet);

    return (
        <View style={[styles.container, viewStyle]}>
            <CustomButton
                style={buttonStyle}
                contentContainerStyle={buttonContentContainerStyle}
                onPress={onClose}
                text={translate(cancelText)}
                textStyle={textStyle}
                type={cancelType}
            />
            <CustomButton
                style={buttonStyle}
                contentContainerStyle={buttonContentContainerStyle}
                onPress={onSubmit}
                text={translate(confirmText)}
                disabled={disabled || isLoading}
                isLoading={isLoading}
                textStyle={textStyle}
                type={confirmType}
            />
        </View>
    );
}

const styleSheet = createStyleSheet(() => ({
    container: {
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
        flexDirection: 'row',
        columnGap: 8,
        zIndex: -30
    },
}));
